import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Icon from 'carbon-react/lib/components/icon';
import { useIntl } from 'react-intl';

import * as styles from './tab-disclaimer.scss';

const PRIVACY_URLS: Record<string, string> = {
  'en-GB': 'https://www.sage.com/en-gb/legal/privacy/',
  'fr-FR': 'https://www.sage.com/fr-fr/legal/privacy/',
  'fr-CA': 'https://www.sage.com/fr-ca/legal/privacy/',
};
const DEFAULT_PRIVACY_URL = 'https://www.sage.com/en-gb/legal/privacy/';

export const TabDisclaimer = () => {
  const intl = useIntl();
  const privacyUrl = PRIVACY_URLS[intl.locale] ?? DEFAULT_PRIVACY_URL;

  return (
    <div className={styles.disclaimerFooter}>
      <Typography fontSize="16px" fontWeight="400" lineHeight="150%" mb={0} color="rgba(0,0,0,0.65)">
        {intl.formatMessage({
          id: 'aiInsights.modal.disclaimer',
          defaultMessage:
            'Check AI content for inaccuracies. This content is for information purposes and is not professional advice.'
        })}
      </Typography>
      <a
        href={privacyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.privacyLink}
      >
        <span className={styles.privacyLinkText}>
          {intl.formatMessage({
            id: 'aiInsights.modal.privacyNotice',
            defaultMessage: 'Privacy notice'
          })}
        </span>
        <span className={styles.linkIcon}>
          <Icon type="link" />
        </span>
      </a>
    </div>
  );
};
